module.exports = __webpack_public_path__ + "static/media/mcafee.e07fb620.png";